// extracted by mini-css-extract-plugin
export default {"container":"TopBar_container__4ZoQM","logoContainer":"TopBar_logoContainer__rrQTi"};